import React from 'react'
import { CardShell } from '@/components/frontend/atoms/content/CardShell'
import { CardBody } from '@/components/frontend/atoms/content/CardBody'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { ResponsiveGrid } from '@/components/frontend/atoms/layout/ResponsiveGrid'
import { FormInput } from '@/components/frontend/atoms/form/FormInput'
import { FormTextarea } from '@/components/frontend/atoms/form/FormTextarea'
import { FormSelect } from '@/components/frontend/atoms/form/FormSelect'
import { SubmitButton } from '@/components/frontend/atoms/form/SubmitButton'
import { FormAlert } from '@/components/frontend/atoms/form/FormAlert'
import { useTranslation } from '@/hooks/useTranslation'

export interface ContactFormProps {
  name: string
  email: string
  company: string
  service: string
  message: string
  onNameChange: (value: string) => void
  onEmailChange: (value: string) => void
  onCompanyChange: (value: string) => void
  onServiceChange: (value: string) => void
  onMessageChange: (value: string) => void
  onSubmit: (e: React.FormEvent) => void
  errors: Record<string, string>
  loading: boolean
  successMessage: string | null
}

export const ContactForm: React.FC<ContactFormProps> = ({
  name, email, company, service, message,
  onNameChange, onEmailChange, onCompanyChange, onServiceChange, onMessageChange,
  onSubmit, errors, loading, successMessage,
}) => {
  const { t } = useTranslation()

  const serviceOptions = [
    { value: 'software-engineering', label: t('contact.service_software') },
    { value: 'automazioni', label: t('contact.service_automation') },
    { value: 'consulenza-ai', label: t('contact.service_ai') },
    { value: 'altro', label: t('contact.service_other') },
  ]

  return (
    <CardShell>
      <CardBody padding="lg">
        <form onSubmit={onSubmit}>
          <Stack gap="4">
            {successMessage && <FormAlert message={successMessage} variant="success" />}
            {errors.general && <FormAlert message={errors.general} variant="error" />}
            <ResponsiveGrid cols="2" gap="4">
              <FormInput id="name" label={t('contact.form_name')} value={name} onChange={onNameChange} placeholder={t('contact.form_name_placeholder')} error={errors.name} required />
              <FormInput id="email" label={t('contact.form_email')} type="email" value={email} onChange={onEmailChange} placeholder={t('contact.form_email_placeholder')} error={errors.email} required />
            </ResponsiveGrid>
            <FormInput id="company" label={t('contact.form_company')} value={company} onChange={onCompanyChange} placeholder={t('contact.form_company_placeholder')} error={errors.company} />
            <FormSelect id="service" label={t('contact.form_service')} value={service} onChange={onServiceChange} options={serviceOptions} placeholder={t('contact.form_service_placeholder')} error={errors.service} />
            <FormTextarea id="message" label={t('contact.form_message')} value={message} onChange={onMessageChange} placeholder={t('contact.form_message_placeholder')} error={errors.message} rows={5} required />
            <SubmitButton loading={loading}>{t('contact.form_submit')}</SubmitButton>
          </Stack>
        </form>
      </CardBody>
    </CardShell>
  )
}
